export default __webpack_public_path__ + "static/media/image-3.d3018983.png";